"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FadeOutText = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var fadeStyle = {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
//  linear-gradient(90deg, rgb(0, 0, 0), 90%, rgba(0, 0, 0, 0) 98% )
var rightFade = __assign(__assign({}, fadeStyle), { WebkitMaskImage: 'linear-gradient(90deg, rgb(0, 0, 0), 90%, rgba(0, 0, 0, 0) 95% )' });
var bottomFade = __assign(__assign({}, fadeStyle), { WebkitMaskImage: 'linear-gradient(180deg, rgb(0, 0, 0), 60%, rgba(0, 0, 0, 0) 95% )' });
var FadeOutText = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)(className), style: __assign(__assign({}, (props.lineclamp == 1 ? rightFade : bottomFade)), { WebkitLineClamp: props.lineclamp }) }, props)));
};
exports.FadeOutText = FadeOutText;
